(function() { window.GUID_32a2a2b3_3bd1_4a80_a554_ccd5bf5eae90 = { getGuid: function() { return "32a2a2b3-3bd1-4a80-a554-ccd5bf5eae90"; } }; })();
//import { Chart } from "../../../../../../Scripts/typings/chartjs/index.esm";
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-winrate",
                        callback: (accordion, e) => {
                            var _a, _b;
                            const statFieldPalette = (_b = (_a = accordion.$Container
                                .find(`#WinRateSectionViewModelV2StatFieldPalette-${accordion.ContentId}`)) === null || _a === void 0 ? void 0 : _a.val()) !== null && _b !== void 0 ? _b : "";
                            if (accordion.IsExpanded) {
                                const $tabmenu = accordion.$Container.find(".tabmenu.control-cs:not(.winrate-tabmenu)");
                                accordion.SetContentSticky($tabmenu);
                                let timePeriod = accordion.$Container
                                    .find(`#WinRateCurrentTimePeriod-${accordion.ContentId}`)
                                    .val();
                                const $dataInput = accordion.$Container.find(`#WinRateSectionViewModelData-${accordion.ContentId}`);
                                const $dataInputV2 = accordion.$Container.find(`#WinRateSectionViewModelDataV2-${accordion.ContentId}`);
                                if ($dataInputV2.length > 0 && $dataInputV2.val() != null) {
                                    const data = JSON.parse($dataInputV2.val());
                                    const allTimeChartControlId = `WinRateSectionChartAllTime-${accordion.ContentId}`;
                                    const lastYearChartControlId = `WinRateSectionChartLastYear-${accordion.ContentId}`;
                                    const allTimeChartRootId = `WinRateSectionChartAllTimeRoot-${accordion.ContentId}`;
                                    const lastYearChartRootId = `WinRateSectionChartLastYearRoot-${accordion.ContentId}`;
                                    const allTimeChartContainerHTML = `
                      <div id="${allTimeChartRootId}" class="">
                      </div>
                      `;
                                    const lastYearChartContainerHTML = `
                        <div id="${lastYearChartRootId}" class="">
                        </div>
                        `;
                                    const $allTimeChartControlElement = accordion.$Container.find(`#${allTimeChartControlId}`);
                                    const $lastYearChartControlElement = accordion.$Container.find(`#${lastYearChartControlId}`);
                                    $allTimeChartControlElement.append(allTimeChartContainerHTML);
                                    $lastYearChartControlElement.append(lastYearChartContainerHTML);
                                    const allTimeChart = new CS.Controls.StackedBarChart({
                                        id: allTimeChartRootId,
                                        controlId: allTimeChartControlId,
                                        datasets: data.All,
                                    });
                                    const lastYearChart = new CS.Controls.StackedBarChart({
                                        id: lastYearChartRootId,
                                        controlId: lastYearChartControlId,
                                        datasets: data.LastYear,
                                    });
                                    allTimeChart.initialize();
                                    lastYearChart.initialize();
                                    const currentHighlightedTab = timePeriod == "all" ? "all" : "last-year";
                                    if (currentHighlightedTab == "all") {
                                        $lastYearChartControlElement.hide();
                                    }
                                    else if (currentHighlightedTab == "last-year") {
                                        $allTimeChartControlElement.hide();
                                    }
                                    accordion.$Control.offon(`click.${accordion.UniqueInstanceId}`, ".tabmenu.control-cs .tab-menu-item", (e) => {
                                        const $clickedTab = $(e.currentTarget);
                                        timePeriod = $clickedTab.attr("id");
                                        const clickedTabIsHighlighted = $clickedTab.hasClass("is-highlighted");
                                        if (!clickedTabIsHighlighted) {
                                            $clickedTab.addClass("is-highlighted");
                                            $clickedTab.siblings().removeClass("is-highlighted");
                                            if (timePeriod == "last-year") {
                                                $allTimeChartControlElement.hide();
                                                $lastYearChartControlElement.show();
                                                lastYearChart.reRender();
                                            }
                                            else if (timePeriod == "all") {
                                                $lastYearChartControlElement.hide();
                                                $allTimeChartControlElement.show();
                                                allTimeChart.reRender();
                                            }
                                        }
                                    });
                                }
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
